import { getFromLocalStorage } from '@/local-storage/utils';
import i18n from './i18n';
import { useEffect } from 'react';

export const useInitTranslations = () => {
  const initializeTranslation = async () => {
    const preference = getFromLocalStorage('language');

    if (preference && (preference === 'nl' || preference === 'en')) {
      i18n.changeLanguage(preference);
    } else {
      const defaultLanguage = navigator.language;

      if (defaultLanguage == null || defaultLanguage.includes('nl')) {
        i18n.changeLanguage('nl');
      } else if (defaultLanguage.includes('en')) {
        i18n.changeLanguage('en');
      } else {
        i18n.changeLanguage('nl');
      }
    }
  };

  useEffect(() => {
    initializeTranslation();
  }, []);
};
